<template>
    
    <div class="main">
        <c-panel>
            <form-gerenciar></form-gerenciar>
        </c-panel>
    </div>
    
</template>
<script>

import formGerenciar from "./form"

export default {
    methods:{ },
    components:{ formGerenciar }
}
</script>
